import { useState } from "react";
import { api } from "../lib/api";
import { SiteFooter } from "../components/SiteFooter";

export function Login() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState<"idle" | "sending" | "sent" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState<string>("");

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setState("sending");
    setErrorMsg("");
    try {
      await api("/auth/request", {
        method: "POST",
        body: JSON.stringify({ email: email.trim() }),
      });
      setState("sent");
    } catch (err) {
      setState("error");
      setErrorMsg(err instanceof Error ? err.message : String(err));
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1 grid place-items-center px-6">
        <div className="max-w-sm w-full space-y-4">
        <h1 className="text-2xl font-semibold">Sign in to MCPBuild</h1>

        {state !== "sent" && (
          <form onSubmit={onSubmit} className="space-y-3">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className="w-full rounded-md bg-bg-1 border border-bg-2 px-3 py-2 text-fg-0"
            />
            <button
              type="submit"
              disabled={state === "sending"}
              className="w-full px-4 py-2 rounded-md bg-accent text-white text-sm disabled:opacity-50"
            >
              {state === "sending" ? "Sending…" : "Send magic link"}
            </button>
          </form>
        )}

        {state === "sent" && (
          <div className="text-fg-1 text-sm">
            Check your inbox for a sign-in link to <strong>{email}</strong>.
          </div>
        )}

        {state === "error" && (
          <div className="text-red-400 text-sm font-mono">{errorMsg}</div>
        )}
        </div>
      </div>
      <SiteFooter />
    </div>
  );
}
